export default __webpack_public_path__ + "static/media/background-new.36bace6c.gif";